<template>
	<form class="profile-form__credentials form__input flex-vertical left-align" @submit.prevent="validateForm" @keydown="form.onKeydown($event)">
		<label class="label left-align" for="currentPassword">
			<b>{{ $t('fields.password') }}</b>
		</label>
		<input class="input" type="password" :placeholder="$t('fields.password')" v-model="form.password" />

		<label class="label left-align" for="newPassword">
			<b>{{ $t('fields.new_password') }}</b>
		</label>
		<input class="input" type="password" :placeholder="$t('fields.new_password')" v-model="form.new_password" />

		<label class="label left-align" for="newPasswordRepeat">
			<b>{{ $t('fields.new_password_confirmation') }}</b>
		</label>
		<input class="input" type="password" :placeholder="$t('fields.new_password_confirmation')" v-model="form.new_password_confirmation" />

		<v-button :loading="form.busy" :disabled="!filled">{{ $t('save') }}</v-button>
	</form>
</template>

<script>
import Form from 'vForm'
export default {
	computed: {
		filled() {
			let { password, new_password, new_password_confirmation } = this.form
			return password && new_password && new_password_confirmation
		},
	},

	data() {
		return {
			form: new Form({
				password: null,
				new_password: null,
				new_password_confirmation: null,
			}),
		}
	},

	methods: {
		validateForm() {
			let { password, new_password, new_password_confirmation } = this.form

			this.form.clear()

			if (!password) this.form.errors.set('password', this.$t('validation.field_is_required', [this.$t('fields.password')]))
			if (!new_password) this.form.errors.set('new_password', this.$t('validation.field_is_required', [this.$t('fields.new_password')]))

			if (new_password !== new_password_confirmation)
				this.form.errors.set('new_password', this.$t('validation.password_confirmation_not_match'))

			if (!this.form.errors.any()) this.changePassword()
			else this.$notifyAllErrors(this.form.errors.all())
		},
		async changePassword() {
			try {
				await this.form.patch('user/profile/password')
				this.$notify(this.$t('success_change_password'), 'success')
				await this.form.reset()
			} catch ({ response }) {
				// this.$notify(response.data.message)
				this.$notifyAllErrors(response.data.errors)
			}
		},
	},
}
</script>

<style lang="scss" scoped></style>
